import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Box, Checkbox, FormControlLabel, TextField, Typography, Stack
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const BulkClientActionsModal = ({
    open,
    onClose,
    onSend,
    selectedCount,
    loading = false,
}) => {
    const { t, i18n } = useTranslation();
    const dir = i18n.dir();

    const [sendWelcomeEmail, setSendWelcomeEmail] = useState(false);
    const [sendWelcomeWhatsApp, setSendWelcomeWhatsApp] = useState(false);
    const [sendDocumentsInfoEmail, setSendDocumentsInfoEmail] = useState(false);
    const [sendDocumentsInfoWhatsApp, setSendDocumentsInfoWhatsApp] = useState(false);
    const [welcomePassword, setWelcomePassword] = useState('');

    const wantsWelcome = sendWelcomeEmail || sendWelcomeWhatsApp;
    const wantsAny = wantsWelcome || sendDocumentsInfoEmail || sendDocumentsInfoWhatsApp;
    const canSubmit = wantsAny && (!wantsWelcome || welcomePassword.trim().length > 0);

    useEffect(() => {
        if (!open) return;
        setSendWelcomeEmail(false);
        setSendWelcomeWhatsApp(false);
        setSendDocumentsInfoEmail(false);
        setSendDocumentsInfoWhatsApp(false);
        setWelcomePassword('');
    }, [open]);

    const handleClose = () => {
        if (loading) return;
        onClose();
    };

    const handleSend = () => {
        onSend({
            sendWelcomeEmail,
            sendWelcomeWhatsApp,
            sendDocumentsInfoEmail,
            sendDocumentsInfoWhatsApp,
            welcomePassword: welcomePassword.trim(),
        });
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth dir={dir}>
            <DialogTitle>{t('bulkSendNotifications')}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {t('selectedClientsCount', { count: selectedCount })}
                </Typography>
                <Stack spacing={1}>
                    <Typography variant="subtitle2">{t('SendClientWelcomeTitle')}</Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sendWelcomeEmail}
                                onChange={(e) => setSendWelcomeEmail(e.target.checked)}
                                color="primary"
                            />
                        }
                        label={t('SendClientWelcomeEmail')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sendWelcomeWhatsApp}
                                onChange={(e) => setSendWelcomeWhatsApp(e.target.checked)}
                                color="primary"
                            />
                        }
                        label={t('SendClientWelcomeWhatsApp')}
                    />
                    {wantsWelcome && (
                        <TextField
                            fullWidth
                            placeholder={t('WelcomePasswordForNotification')}
                            value={welcomePassword}
                            onChange={(e) => setWelcomePassword(e.target.value)}
                            type="password"
                            autoComplete="new-password"
                            size="small"
                            sx={{ mt: 0.5 }}
                        />
                    )}
                    <Typography variant="caption" color="text.secondary">
                        {t('SendClientWelcomeHint')}
                    </Typography>

                    <Typography variant="subtitle2" sx={{ mt: 1 }}>{t('SendDocumentsSubmissionTitle')}</Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sendDocumentsInfoEmail}
                                onChange={(e) => setSendDocumentsInfoEmail(e.target.checked)}
                                color="primary"
                            />
                        }
                        label={t('SendDocumentsSubmissionEmail')}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={sendDocumentsInfoWhatsApp}
                                onChange={(e) => setSendDocumentsInfoWhatsApp(e.target.checked)}
                                color="primary"
                            />
                        }
                        label={t('SendDocumentsSubmissionWhatsApp')}
                    />
                    <Typography variant="caption" color="text.secondary">
                        {t('SendDocumentsSubmissionHint')}
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>{t('cancel')}</Button>
                <Button variant="contained" onClick={handleSend} disabled={!canSubmit || loading}>
                    {t('Send')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BulkClientActionsModal;
